import React from "react";
import Input from "components/Input";
import { withTranslation } from "react-i18next";
import { RedDot } from "..";

const EmailInput = ({
  t,
  value,
  error,
  onChange,
  readOnly = false,
  disabled = false,
  classes = "",
}) => {
  return (
    <Input
      Classes={classes}
      Title={
        <>
          {t("form.fields.emailAddress")} <RedDot />
        </>
      }
      Type="email"
      Placeholder={t("form.placeholder1", {
        field: t("form.fields.emailAddress"),
      })}
      Name="emailId"
      ReadOnly={readOnly}
      Disabled={disabled}
      HandleChange={disabled ? () => {} : onChange}
      Error={error}
      Value={value}
    />
  );
};

export default withTranslation()(EmailInput);
